import * as api from "./api";
import * as modelsGet from "../models/get";
import * as modelsPost from "../models/post";

/**
 * Erstellt einen neuen Eintrag.
 * @param jsonData Ein JSON-Objekt mit den Daten die gesendet werden sollen.
 */
export function post(eventid: number, comment: string): JQueryPromise<any>
{
    var model: modelsPost.IComment = {
        event_id: eventid,
        comment: comment
    };

    return api.post({
        contentType: "application/json",
        endpoint: "api/comments",
        data: JSON.stringify(model)
    });
}

/**
 * Ändert einen vorhandenen Eintrag.
 * @param id Die ID des Eintrags.
 * @param jsonData Ein JSON-Objekt mit den Daten die gesendet werden sollen.
 */
export function put(id: number, comment: string): JQueryPromise<any>
{
    var model: modelsPost.IComment = {
        comment: comment
    };

    return api.put({
        contentType: "application/json",
        endpoint: `api/comments/${id}`,
        data: JSON.stringify(model)
    });
}

/**
 * Löscht einen vorhandenen Eintrag.
 * @param id Die ID des Eintrags.
 */
export function remove(id: number): JQueryPromise<any>
{
    return api.remove({
        endpoint: `api/comments/${id}`
    });
}